export default "__VITE_ASSET__b000fd29__"